import { Component, inject, OnInit } from '@angular/core';
import { EnvService } from '@forgerock/backstage-ui-core';
import { FeaturedPageService } from '../featured-page.service';
import { DashboardEnv } from '../model/dashboard-env';
import { FeaturedPage } from '../model/featured-page';

@Component({
  selector: 'app-dashboard-downloads-panel',
  templateUrl: './dashboard-downloads-panel.component.html',
  styleUrls: [ './dashboard-downloads-panel.component.scss' ],
  standalone: false
})
export class DashboardDownloadsPanelComponent implements OnInit {
  readonly loadingCards = Array.from({ length: 6 });
  pages: FeaturedPage[] = [];
  downloadsUrl: string | null = null;
  loading = true;
  failed = false;

  private readonly featuredPageService = inject(FeaturedPageService);
  private readonly envService = inject(EnvService<DashboardEnv>);

  getProductId(path: string): string {
    return path?.split('/')[0] ?? '';
  }

  async ngOnInit(): Promise<void> {
    try {
      const env = await this.envService.get();
      this.downloadsUrl = env.downloadsBaseUrl;
      this.pages = (await this.featuredPageService.getFeaturedPages()).slice(0, 6);
    } catch {
      this.failed = true;
    } finally {
      this.loading = false;
    }
  }
}
